/* eslint-disable max-len */

export const text = [`С 2014 года по февраль 2016 года на памятнике выполнены масштабные реставрационные работы. Глядя на фасад, легко понять, что все зубцы  были выложены заново. По образцам сохранившихся деталей полностью воссозданы: чугунная винтовая лестница,  полы с использованием подлинных каменных плит, паркеты, дверни и окна.`];
export const text2 = [''];
